<template>
  <list-template :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div
              class="header-title wrapper-content__main font-size__large font-weight__bold"
            >
              Cấu hình luồng
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #body>
            <VuePerfectScrollbar class="scroll-CauHinhLuong">
              <div class="docDetail diagram">
                <el-col :span="18" class="display_diagram">
                  <div
                    class="panel-body points demo flow_chart"
                    id="points"
                    ref="points"
                  ></div>
                </el-col>
                <el-col :span="6" class="updateDiagram">
                  <vb-flow-detail-panel
                    ref="vbFlowDetailPanel"
                    :vbFlowForm="vbFlowForm"
                    @editVbFlowForm="openVbFlowDetailDialog"
                    @submit="saveFlow"
                  ></vb-flow-detail-panel>
                </el-col>
              </div>
            </VuePerfectScrollbar>
          </template>
        </list-template>

        <vb-flow-detail-dialog
          v-if="isEnableVbFlowDetailDialog"
          :isOpen="isOpenVbFlowDetailDialog"
          :vbFlowForm="vbFlowForm"
          @dialogClosed="isEnableVbFlowDetailDialog = false"
          @closeDialog="isOpenVbFlowDetailDialog = false"
          @submit="updateVbFlowForm"
        />

        <vb-step-detail-dialog
          v-if="isEnableVbStepDetailDialog"
          :isOpen="isOpenVbStepDetailDialog"
          :context="context"
          @dialogClosed="isEnableVbStepDetailDialog = false"
          @closeDialog="isOpenVbStepDetailDialog = false"
          @submit="updateVbStepForm"
          @delete="deleteVbStepForm"
        />

        <vb-step-to-step-dialog
          v-if="isEnableVbStepToStepDialog"
          :isOpen="isOpenVbStepToStepDialog"
          :context="context"
          :fromPoint="selectedPoint"
          @dialogClosed="isEnableVbStepToStepDialog = false"
          @closeDialog="isOpenVbStepToStepDialog = false"
          @submit="addLines"
        />
      </div>
    </template>
  </list-template>
</template>

<script>
import $ from "jquery";
import { jsPlumb } from "jsplumb";
import uuidv4 from "uuid/v4";
import Vue from "vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import headerTemplate from "../../../components/header/main-header";
import SubHeader from "../../../components/main/sub-header";
import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import cauHinhLuongUtils from "../../../services/cauhinhluong/cauHinhLuongUtils";
import h from "../../../services/h";
import utils from "../../../services/utils";
import vbFlowService from "../../../services/vbFlowService";
import vbStepInfoViewService from "../../../services/vbStepInfoViewService";
import vbStepService from "../../../services/vbStepService";
import vbStepToStepService from "../../../services/vbStepToStepService";
import ListTemplate from "../../common/list";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import point from "./point";
import VbFlowDetailDialog from "./vb-flow-detail-dialog";
import VbFlowDetailPanel from "./vb-flow-detail-panel";
import VbStepDetailDialog from "./vb-step-detail-dialog";
import VbStepToStepDialog from "./vb-step-to-step-dialog";

const pointClass = Vue.extend(point);

export default {
  name: "cau-hinh-luong-detail-v2",
  mixins: [handleRequestErrorMixin],

  components: {
    VbStepDetailDialog,
    VbFlowDetailPanel,
    VbStepToStepDialog,
    SubHeader,
    VbFlowDetailDialog,
    ListTemplate,
    headerTemplate,
    VuePerfectScrollbar,
  },

  data() {
    return {
      // CONFIGS: {
      //   DEFAULT_SIZE: {w: 200, h: 100},
      //   SPLIT_SIZE: {x: 30, y: 30},
      //   DEFAULT_OFFSET: {x: 10, y: 10}
      // },

      configs: {
        offsetX: 50,
        offsetY: 50,
        size: 200,
      },

      perfectScrollbarSetting: { maxScrollbarLength: 350 },

      vbFlowForm: {
        flowName: null,
        flowCode: null,
        flowType: null,
        deptId: null,
        note: null,
        isDefault: null,
        status: null,
        // hideVtComments: null
      },

      vbStepForms: [],
      vbStepInfoForms: [],
      vbStepToStepForms: [],

      vbFlow: null,
      vbSteps: null,
      vbStepInfos: null,
      vbStepToSteps: null,

      points: [], //{_id, name, x, y, type, vbStepForm}; type: start/end/null;
      lines: [], //{from, to}; from/to: point._id;
      instance: null,
      selectedPoint: null,
      currentAction: null,

      isEnableVbFlowDetailDialog: false,
      isOpenVbFlowDetailDialog: false,
      isEnableVbStepDetailDialog: false,
      isOpenVbStepDetailDialog: false,
      isOpenVbStepToStepDialog: false,
      isEnableVbStepToStepDialog: false,
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },

    isEdit() {
      return !!this.id;
    },

    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    isOutgoingFlow() {
      return cauHinhLuongUtils.isOutgoingFlow(this.vbFlowForm);
    },

    isIncomingFlow() {
      return cauHinhLuongUtils.isIncomingFlow(this.vbFlowForm);
    },

    context() {
      return {
        vbFlowForm: this.vbFlowForm,
        vbStepForms: this.vbStepForms,
        vbStepInfoForms: this.vbStepInfoForms,
        vbStepToStepForms: this.vbStepToStepForms,
        currentAction: this.currentAction,
        selectedPoint: this.selectedPoint,
        points: this.points,
        lines: this.lines,

        vbFlow: this.vbFlow,
        vbSteps: this.vbSteps,
        vbStepInfos: this.vbStepInfos,
        vbStepToSteps: this.vbStepToSteps,
      };
    },
  },

  watch: {
    isOpenVbFlowDetailDialog(newValue) {
      if (newValue) this.isEnableVbFlowDetailDialog = true;
    },

    isOpenVbStepDetailDialog(newValue) {
      if (newValue) this.isEnableVbStepDetailDialog = true;
    },

    isOpenVbStepToStepDialog(newValue) {
      if (newValue) this.isEnableVbStepToStepDialog = true;
    },
  },

  // async created() {
  //   if (!this.userDeptRole) return;
  // },

  async mounted() {
    if (!this.userDeptRole) return;
    if (!this.isEdit) {
      this.openVbFlowDetailDialog();
    } else {
      await this.initComponentForEdit();
      await this.$refs.vbFlowDetailPanel.initComponent();
      await this.initDiagram();
      this.redrawDiagram();
    }
  },

  methods: {
    initBindDataToForms() {
      this.bindVbFlowForm();
      this.bindVbStepForms();
      this.bindVbStepInfoForms();
      this.bindVbStepToStepForms();
      this.initDiagramData();
    },

    isHasConnection({ from, to }) {
      return h.exists(
        this.lines,
        (line) => line.from === from && line.to === to
      );
    },

    calculatePointsPosition() {
      //xác định lvl cho từng point;
      let startPoint = h.find(this.points, (point) =>
        cauHinhLuongUtils.isStartPoint(point)
      );

      let arr_ = [{ point: startPoint, lvl: 0 }];
      let markedPoint_ = [startPoint];
      let maxLvl = 0;

      h.each(arr_, (item) => {
        //tìm các điểm tiếp theo;
        let nextPoints = h.findAll(
          this.points,
          (point) =>
            markedPoint_.indexOf(point) === -1 &&
            this.isHasConnection({ from: item.point._id, to: point._id })
        );

        h.each(nextPoints, (point) =>
          arr_.push({ point: point, lvl: item.lvl + 1 })
        );

        if (nextPoints && nextPoints.length) {
          maxLvl = Math.max(maxLvl, item.lvl + 1);
          markedPoint_.push(...nextPoints);
        }
      });
      //xác định lvl cho từng point:end;

      let offsetX = this.configs.offsetX;
      let offsetY = this.configs.offsetY;
      let d = this.configs.size;

      for (let lvl = maxLvl; lvl >= 0; lvl--) {
        h.each(
          h.findAll(arr_, (item) => item.lvl === lvl),
          (item, index) => {
            item.point.x = lvl * d + offsetX;
            item.point.y = index * d + offsetY;
          }
        );
      }
    },

    initDiagramData() {
      this.points = [];
      this.lines = [];

      let startPoint = this.addStartPoint();
      //nếu là luồng văn bản đến thì không cần thêm node kết thúc;
      let endPoint = this.isOutgoingFlow ? this.addEndPoint() : null;

      //thêm danh sách points;
      h.each(this.vbStepForms, (vbStepForm) =>
        this.createAPoint({ vbStepForm })
      );

      //thêm danh sách lines;
      h.each(this.vbStepToStepForms, (vbStepToStepForm) =>
        this.lines.push({
          from: vbStepToStepForm.preStepId,
          to: vbStepToStepForm.nextStepId,
          _id: vbStepToStepForm.id,
        })
      );

      //thêm line từ các điểm đầu, cuối;
      h.each(this.points, (point) => {
        if (cauHinhLuongUtils.isBatDauPoint(point))
          this.connectPoints({
            from: startPoint._id,
            to: point._id,
            id: null,
          });

        if (endPoint && cauHinhLuongUtils.isKetThucPoint(point))
          this.connectPoints({
            from: point._id,
            to: endPoint._id,
            id: null,
          });
      });

      this.calculatePointsPosition();
    },

    bindVbStepForms() {
      this.vbStepForms = h.collect(this.vbSteps, (vbStep) => {
        return {
          id: vbStep.id,
          stepName: vbStep.stepName,
          signSmartCA: vbStep.signSmartCA,
          signType: vbStep.signType,
          signToken: vbStep.signToken,
          posType: vbStep.posType,
          stepType: vbStep.stepType,
          status: vbStep.status,
          endTask: vbStep.endTask,
          code: vbStep.code,
          isAbleToReject: vbStep.isAbleToReject,
        };
      });
    },

    bindVbStepInfoForms() {
      this.vbStepInfoForms = h.collect(this.vbStepInfos, (vbStepInfo) => {
        return {
          id: vbStepInfo.id,
          stepId: vbStepInfo.stepId,
          deptId: vbStepInfo.deptId,
          roleId: vbStepInfo.roleId,
          userId: vbStepInfo.userId,
          status: vbStepInfo.status,
          deptName: vbStepInfo.deptName,
          roleName: vbStepInfo.roleName,
          fullName: vbStepInfo.fullName,
          order: vbStepInfo.order,
          signType: vbStepInfo.signType,
          signSmartCA: vbStepInfo.signSmartCA,
          signToken: vbStepInfo.signToken,
        };
      });
    },

    bindVbStepToStepForms() {
      this.vbStepToStepForms = h.collect(this.vbStepToSteps, (vbStepToStep) => {
        return {
          id: vbStepToStep.id,
          preStepId: vbStepToStep.preStepId,
          nextStepId: vbStepToStep.nextStepId,
          action: vbStepToStep.action,
        };
      });
    },

    bindVbFlowForm() {
      this.vbFlowForm.flowName = this.vbFlow.flowName;
      this.vbFlowForm.flowCode = this.vbFlow.flowCode;
      this.vbFlowForm.flowType = this.vbFlow.flowType;
      this.vbFlowForm.deptId = this.vbFlow.deptId;
      this.vbFlowForm.note = this.vbFlow.note;
      this.vbFlowForm.isDefault = this.vbFlow.isDefault;
      this.vbFlowForm.status = this.vbFlow.status;
      // this.vbFlowForm.hideVtComments = this.vbFlow.hideVtComments;
    },

    loadVbFlow() {
      return vbFlowService
        .findById(this.id)
        .then((response) => (this.vbFlow = response.data));
    },

    loadVbSteps() {
      return vbStepService
        .findAllByFlowId(this.id)
        .then((response) => (this.vbSteps = response.data));
    },

    loadVbStepInfos() {
      return vbStepInfoViewService
        .findAllByFlowId(this.id)
        .then((response) => (this.vbStepInfos = response.data));
    },

    loadVbStepToSteps() {
      return vbStepToStepService
        .findAllByFlowId(this.id)
        .then((response) => (this.vbStepToSteps = response.data));
    },

    //true = nếu có kết nối tới node khác không phải startPoint && endPoint
    isHasNextSteps({ vbStepForm, startPoint, endPoint }) {
      return h.exists(
        this.lines,
        (line) =>
          line.from === vbStepForm.id &&
          startPoint._id !== line.to &&
          (endPoint ? endPoint._id : null) !== line.to
      );
    },

    getPosType({ vbStepForm, startPoint, endPoint }) {
      let isBatDau = this.isHasConnection({
        from: startPoint._id,
        to: vbStepForm.id,
      });
      //đối với luồng văn bản đến, thì nút kết thúc = việc có line nào xuất phát từ node này;
      let isKetThuc = this.isOutgoingFlow
        ? this.isHasConnection({
            from: vbStepForm.id,
            to: endPoint._id,
          })
        : !h.exists(this.lines, (line) => line.from === vbStepForm.id);

      let posType = null;
      if (isBatDau) posType = constants.STEP_POS_TYPE.BAT_DAU;
      if (isKetThuc)
        posType = (posType || 0) + constants.STEP_POS_TYPE.KET_THUC;
      return posType;
    },

    convertToSubmitForm() {
      let startPoint = h.find(this.points, (point) =>
        cauHinhLuongUtils.isStartPoint(point)
      );

      let endPoint = h.find(this.points, (point) =>
        cauHinhLuongUtils.isEndPoint(point)
      );

      let vbFlow = {
        flowName: this.vbFlowForm.flowName,
        flowType: this.vbFlowForm.flowType,
        deptId: this.vbFlowForm.deptId,
        note: this.vbFlowForm.note,
        flowCode: this.vbFlowForm.flowCode,
        isDefault: this.vbFlowForm.isDefault,
        status: this.vbFlowForm.status,
      };

      let steps = h.collect(this.vbStepForms, (vbStepForm) => {
        return {
          id: vbStepForm.id,
          stepName: vbStepForm.stepName,
          signType: vbStepForm.signType,
          signSmartCA: vbStepForm.signSmartCA,
          signToken: vbStepForm.signToken,
          posType: this.getPosType({ vbStepForm, startPoint, endPoint }),
          stepType: vbStepForm.stepType,
          status: vbStepForm.status,
          endTask: vbStepForm.endTask,
          code: vbStepForm.code,
          isAbleToReject: vbStepForm.isAbleToReject,
          isHasNextSteps: this.isHasNextSteps({
            vbStepForm,
            startPoint,
            endPoint,
          })
            ? constants.TRUE
            : constants.FALSE,
        };
      });

      let vbStepToSteps = h.collect(
        h.findAll(this.vbStepToStepForms, (vbStepToStepForm) => {
          return (
            startPoint._id !== vbStepToStepForm.preStepId &&
            (endPoint ? endPoint._id : null) !== vbStepToStepForm.nextStepId
          );
        }),
        (vbStepToStepForm) => {
          return {
            id: vbStepToStepForm.id,
            preStepId: vbStepToStepForm.preStepId,
            nextStepId: vbStepToStepForm.nextStepId,
            action: vbStepToStepForm.action,
          };
        }
      );

      let stepInfos = h.collect(this.vbStepInfoForms, (vbStepInfoForm) => {
        return {
          id: vbStepInfoForm.id,
          stepId: vbStepInfoForm.stepId,
          deptId: vbStepInfoForm.deptId,
          roleId: vbStepInfoForm.roleId,
          userId: vbStepInfoForm.userId,
          status: vbStepInfoForm.status,
          order: vbStepInfoForm.order,
          signType: vbStepInfoForm.signType,
          signSmartCA: vbStepInfoForm.signSmartCA,
          signToken: vbStepInfoForm.signToken,
        };
      });

      return {
        vbFlow,
        steps,
        vbStepToSteps,
        stepInfos,
      };
    },

    saveFlow() {
      this.validateHasNoNode().then(() => {
        let form = this.convertToSubmitForm();
        if (!this.isEdit) {
          return vbFlowService
            .insert(form)
            .then(() => {
              this.$message.success(
                errorMessageFilter({ errorCode: "vbFlow.save.success" })
              );
              this.$router.replace({ name: "CauHinhLuong" });
            })
            .catch((error) => this.commonHandleRequestError(error));
        } else {
          return vbFlowService
            .update(this.id, form)
            .then(() => {
              this.$message.success(
                errorMessageFilter({ errorCode: "vbFlow.update.success" })
              );
              this.$router.replace({ name: "CauHinhLuong" });
            })
            .catch((error) => this.commonHandleRequestError(error));
        }
      });
    },

    validateHasNoNode() {
      return new Promise((resolve) => {
        if (!this.vbStepForms || !this.vbStepForms.length) {
          this.$message.error(
            errorMessageFilter({ errorCode: "vbFlow.hasNoNode" })
          );
        } else {
          resolve();
        }
      });
    },

    deleteVbStepForm({ id }) {
      h.removeAll(this.points, (point) => point._id === id);
      h.removeAll(this.vbStepForms, (vbStepForm) => vbStepForm.id === id);
      h.removeAll(
        this.vbStepInfoForms,
        (vbStepInfoForm) => vbStepInfoForm.stepId === id
      );

      h.removeAll(this.lines, (line) => line.from === id || line.to === id);
      h.removeAll(
        this.vbStepToStepForms,
        (vbStepToStepForm) =>
          vbStepToStepForm.preStepId === id ||
          vbStepToStepForm.nextStepId === id
      );

      this.$nextTick(() => this.redrawDiagram());
      this.isOpenVbStepDetailDialog = false;
    },

    addLines({ forms }) {
      h.each(forms, (form) =>
        this.connectPoints({
          from: form.preStepId,
          to: form.nextStepId,
          id: form.id,
        })
      );
      this.isOpenVbStepToStepDialog = false;
      this.redrawDiagram();
    },

    openAddNodeDialog({ point }) {
      this.currentAction = constants.CAU_HINH_LUONG_PAGE.ACTION.ADD_NODE;
      this.selectedPoint = point;
      this.isOpenVbStepDetailDialog = true;
    },

    viewNodeDetail({ point }) {
      this.currentAction = constants.CAU_HINH_LUONG_PAGE.ACTION.VIEW_NODE;
      this.selectedPoint = point;
      this.isOpenVbStepDetailDialog = true;
    },

    openAddLineDialog({ point }) {
      this.isOpenVbStepToStepDialog = true;
      this.selectedPoint = point;
    },

    createElementForAPoint({ point }) {
      let pointDiv = new pointClass({
        propsData: {
          point: point,
        },
      });

      pointDiv.$on("addNode", this.openAddNodeDialog);
      pointDiv.$on("addLine", this.openAddLineDialog);
      pointDiv.$on("viewDetail", this.viewNodeDetail);

      pointDiv.$mount();

      $(this.$refs.points).append(pointDiv.$el);

      //xác định vị trí của point;
      $(pointDiv.$el).css("left", point.x);
      $(pointDiv.$el).css("top", point.y);

      //tạo điểm để nối các point
      h.each(["Right", "Left"], (position) => {
        this.instance.addEndpoint(
          point._id,
          {
            uuid: `${point._id}-${position}`,
            anchor: position,
            maxConnections: -1,
            connectorStyle: { stroke: "black" },
          },
          {
            isSource: true,
            isTarget: true,
            dragAllowedWhenFull: true,
          }
        );
      });

      this.instance.draggable(`${point._id}`, {
        stop({ pos }) {
          point.x = pos[0];
          point.y = pos[1];
        },
      });

      return pointDiv;
    },

    /**
     *
     * @param from: fromPoint.i
     * @param to: toPoint.id
     */
    openEditLine({ from, to }) {
      utils
        .confirm(
          this.$confirm,
          errorMessageFilter({
            errorCode: "vbFlow.vbStepToStep.delete.confirm",
          })
        )
        .then(() => {
          h.removeAll(
            this.lines,
            (line) => line.from === from && line.to === to
          );
          h.removeAll(
            this.vbStepToStepForms,
            (vbStepToStepForm) =>
              vbStepToStepForm.preStepId === from &&
              vbStepToStepForm.nextStepId === to
          );
          this.redrawDiagram();
        });
    },

    drawLine({ from, to }) {
      this.instance.connect({
        uuids: [`${from}-Right`, `${to}-Left`],
        overlays: [["Label", { label: "Chuyển", id: uuidv4() }]],
      });
    },

    initDiagram() {
      return this.initJsPlumb().then(() => {
        this.instance.batch(() => {
          this.instance.bind("dblclick", (connection, originalEvent) =>
            this.openEditLine({
              from: connection.sourceId,
              to: connection.targetId,
            })
          );
        });
      });
    },

    redrawDiagram() {
      this.instance.empty(this.$refs.points);

      h.each(this.points, (point) => {
        this.createElementForAPoint({ point });
      });

      h.each(this.lines, (line) => this.drawLine(line));
    },

    async initDiagramForCreate() {
      this.addStartPoint();
      //nếu là luồng văn bản đến thì không cần thêm node kết thúc;
      if (this.isOutgoingFlow) this.addEndPoint();
      await this.initDiagram();
      this.redrawDiagram();
    },

    addStartPoint() {
      return this.createAPoint({
        vbStepForm: null,
        fromPoint: null,
        type: constants.CAU_HINH_LUONG_PAGE.POINT.TYPE.START,
      });
    },

    addEndPoint() {
      let endPoint = this.createAPoint({
        vbStepForm: null,
        fromPoint: null,
        type: constants.CAU_HINH_LUONG_PAGE.POINT.TYPE.END,
      });
      endPoint.x = this.configs.offsetX + 3 * this.configs.size;
      endPoint.y = this.configs.offsetY;
      return endPoint;
    },

    initJsPlumb() {
      return new Promise((resolve) => {
        jsPlumb.ready(() => {
          this.instance = jsPlumb.getInstance({
            Connector: ["Bezier", { curviness: 50 }],
            Endpoint: ["Blank", { radius: 5 }],
            DragOptions: { cursor: "pointer", zIndex: 5000 },
            // PaintStyle: { lineWidth: 5, stroke: '#445566' },
            PaintStyle: { strokeWidth: 2, stroke: "#445566", dashstyle: "4 2" },
            EndpointStyle: { radius: 9, fill: "#445566", stroke: "red" },
            HoverPaintStyle: { stroke: "#ec9f2e", lineWidth: 4 },
            EndpointHoverStyle: { fill: "#ec9f2e", stroke: "#acd" },
            ConnectionOverlays: [
              ["Arrow", { location: 0.8 }, { foldback: 0.7, width: 12 }],
            ],
            Container: "points",
          });
          resolve();
        });
      });
    },

    openVbFlowDetailDialog() {
      this.isOpenVbFlowDetailDialog = true;
    },

    updateVbStepForm({ form }) {
      this.isOpenVbStepDetailDialog = false;
      switch (this.currentAction) {
        case constants.CAU_HINH_LUONG_PAGE.ACTION.ADD_NODE:
          this.addANode(form);
          break;
        case constants.CAU_HINH_LUONG_PAGE.ACTION.VIEW_NODE:
          this.updateANode(form);
          break;
      }
      this.$nextTick(() => this.redrawDiagram());
    },

    updateANode({ vbStepForm, vbStepInfoForms }) {
      let vbStepForm_ = this.selectedPoint.vbStepForm;
      vbStepForm_.stepName = vbStepForm.stepName;
      vbStepForm_.signType = vbStepForm.signType;
      vbStepForm_.signSmartCA = vbStepForm.signSmartCA;
      vbStepForm_.signToken = vbStepForm.signToken;
      vbStepForm_.stepType = vbStepForm.stepType;
      vbStepForm_.status = vbStepForm.status;
      vbStepForm_.code = vbStepForm.code;
      vbStepForm_.endTask = vbStepForm.endTask;
      vbStepForm_.isAbleToReject = vbStepForm.isAbleToReject;

      this.updateVbStepInfoForms({ vbStepForm: vbStepForm_, vbStepInfoForms });
    },

    //remove hết stepInfoForms cũ & add vbStepInfoForms mới;
    updateVbStepInfoForms({ vbStepForm, vbStepInfoForms }) {
      let stepId = vbStepForm.id;
      h.removeAll(this.vbStepInfoForms, (item) => item.stepId === stepId);
      this.addVbStepInfoForms({ vbStepForm, vbStepInfoForms });
    },

    addANode({ vbStepForm, vbStepInfoForms }) {
      vbStepForm.id = uuidv4();

      if (this.isOutgoingFlow)
        vbStepForm.stepType = constants.STEP.STEP_TYPE.CANHAN;
      this.vbStepForms.push(vbStepForm);
      this.addVbStepInfoForms({ vbStepForm, vbStepInfoForms });

      let fromPoint = this.selectedPoint;
      //tạo 1 point từ step được tạo
      let toPoint = this.createAPoint({ vbStepForm, fromPoint });
      this.connectPoints({ from: fromPoint._id, to: toPoint._id, id: null });
    },

    addVbStepInfoForms({ vbStepForm, vbStepInfoForms }) {
      h.each(
        vbStepInfoForms,
        (vbStepInfoForm) => (vbStepInfoForm.stepId = vbStepForm.id)
      );
      this.vbStepInfoForms.push(...vbStepInfoForms);
    },

    createAPoint({ vbStepForm, fromPoint, type }) {
      let toPoint = {
        _id: vbStepForm ? vbStepForm.id : uuidv4(),
        x: fromPoint ? fromPoint.x + this.configs.size : this.configs.offsetX,
        y: fromPoint ? fromPoint.y : this.configs.offsetY,
        vbStepForm: vbStepForm,
        type: type,
      };
      this.points.push(toPoint);
      return toPoint;
    },

    connectPoints({ from, to, id }) {
      this.vbStepToStepForms.push({
        id: id,
        preStepId: from,
        nextStepId: to,
        action: "Chuyển",
      });
      let line = { from: from, to: to, _id: id };
      this.lines.push(line);
    },

    updateVbFlowForm({ form }) {
      this.vbFlowForm.flowName = form.flowName;
      this.vbFlowForm.flowCode = form.flowCode;
      this.vbFlowForm.flowType = form.flowType;
      this.vbFlowForm.deptId = form.deptId;
      this.vbFlowForm.note = form.note;
      this.vbFlowForm.isDefault = form.isDefault;
      this.vbFlowForm.status = form.status;
      // this.vbFlowForm.hideVtComments = form.hideVtComments;

      this.isOpenVbFlowDetailDialog = false;

      //trong TH tạo luồng > sau khi thực hiện thêm thông tin luồng thì tạo node bắt đầu;
      if (!this.instance) this.initDiagramForCreate();

      this.$refs.vbFlowDetailPanel.initComponent();
    },

    async initComponentForEdit() {
      await this.loadVbFlow();
      await this.loadVbSteps();
      await this.loadVbStepInfos();
      await this.loadVbStepToSteps();
      this.initBindDataToForms();
    },
  },
};
</script>
<style>
.content-fullHeight {
  height: 100%;
}

.display_diagram {
  position: relative;
}

.display_diagram::before {
  position: absolute;
  width: 30px;
  background-color: blue;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 10;
}

.dialogCauHinhLuong {
  height: 100%;
}

.dialogCauHinhLuong .dialog-body {
  margin: 20px 0;
  padding: 0 20px;
}

.dialogCauHinhLuong .dialog-body .list-collapse__transfer {
  border: 1px solid #ceced2;
  padding: 10px;
  border-radius: 4px;
  height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.dialogCauHinhLuong .el-form--label-top .el-form-item__label {
  line-height: 30px;
}

.dialogCauHinhLuong .dialog-body .el-collapse-item .el-collapse-item__header {
  color: #2b2d50;
  font-weight: 600;
  height: 40px;
}

.dialogCauHinhLuong .dialog-body .el-collapse-item__wrap {
  padding-left: 10px;
}

.dialogCauHinhLuong .dialog-body .el-collapse-item__content {
  padding-bottom: 10px;
}

.dialogCauHinhLuong .dialog-body .btn-selected__filter {
  background-color: #007aff;
  color: white;
  font-weight: 600;
  outline: none;
  border: none;
  padding: 13px 15px;
}

.people__name {
  color: #2d3e4f;
  font-size: 14px;
}

.people__position {
  color: #abb4bd;
  font-size: 12px;
}

/*dialog_body chuyen xu ly*/

.dialogCauHinhLuong .dialog-body .display-list__selected .list-selected {
  background-color: #f3f5f7;
  border-radius: 4px;
  border: 1px solid #e3e8ee;
  margin-bottom: 10px;
  height: 300px;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .header {
  box-shadow: 0 0.5px 0 0 rgba(0, 0, 0, 0.05),
    0 0.5px 1.5px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  padding: 15px 45px;
  font-size: 15px;
  color: #2b2d50;
  border-radius: 4px 4px 0 0;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .header
  > div {
  width: 325px;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  .selected-user
  .index {
  width: calc(45px - 5px);
}

.check-list {
  width: 300px;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  .selected-user
  .index
  span {
  background-color: #e0e5eb;
  padding: 5px;
  border-radius: 2px;
  font-weight: 600;
}

.dialogCauHinhLuong .dialog-body .display-list__selected .list-selected .body {
  overflow-y: auto;
  height: calc(100% - 44px);
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  .list-filter {
  padding: 5px 0;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  > .title {
  margin-bottom: 10px;
  margin-left: 45px;
  font-weight: 600;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  .selected-user:first-child {
  margin-top: 2px;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  .selected-user {
  background-color: #f3f5f7;
  z-index: 100;
  margin-bottom: 1px;
  padding: 5px 0;
  box-shadow: 0 0.5px 0.5px 0 rgba(0, 0, 0, 0.1);
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  .selected-user
  .info
  .people__name {
  margin-bottom: 5px;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  .selected-user
  .btn-unselect {
  display: none;
  box-shadow: 0 0.5px 1.5px 0 rgba(0, 0, 0, 0.15),
    0 1px 1.5px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  transition: 0.2s;
  color: #2b2d50;
  margin-right: 25px;
  padding: 10px;
  outline: none;
  border: none;
  border-radius: 4px;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  .selected-user:hover {
  transition: 0.14s;
  box-shadow: 0 0.5px 0 0 rgba(0, 0, 0, 0.1);
  background-color: rgba(0, 0, 0, 0.05);
  margin-bottom: 0;
}

.dialogCauHinhLuong
  .dialog-body
  .display-list__selected
  .list-selected
  .body
  .selected-user:hover
  .btn-unselect {
  display: inline-block;
  transition: 0.3s;
}

.listFilter {
  padding: 0;
  margin: 0;
}

.listFilter .filter-item {
  padding: 5px 10px;
  border-radius: 4px;
  transition: 0.3s;
  font-size: 15px;
  font-weight: 500;
}

.listFilter .filter-item:hover {
  transition: 0.4s;
  background-color: #e3e8ee;
}

/*dialog_header*/
.dialogCauHinhLuong .dialog-header {
  box-shadow: 0 0.5px 0 0 rgba(0, 0, 0, 0.05), 0 1px 2.5px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  padding: 15px 20px;
}

.dialogCauHinhLuong .dialog-header .dialog-title {
  color: #2d3e4f;
  font-weight: bold;
}

.btn-close__large {
  font-size: 25px;
  color: red;
}

/*dialog_footer*/
.submit-area {
  padding: 8px 20px;
  box-shadow: 0 -0.5px 0 0 #e3e8ee;
  background-color: #e3e8ee;
}

/*  */
.updateDiagram .dialogTransferHandling.update_Line,
.updateDiagram .dialogTransferHandling.update_Node {
  height: 100%;
  box-shadow: -0.5px 0 0 0 #e3e8ee;
}

.updateDiagram .update_Node .dialog-body,
.updateDiagram .update_Line .dialog-body {
  height: 100%;
}

.scroll-CauHinhLuong {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  margin: auto;
}

.scroll-CapNhatLuong {
  max-width: 100%;
  width: 100%;
  height: 100%;
  max-height: calc(100% - 54px - 45px);
  margin: auto;
}

.diagram {
  width: 100%;
  background-color: white;
  height: 100%;
}

.display_diagram,
#points {
  background-image: url("https://sitejerk.com/images/white-2.png");
  background-position: center;
  background-repeat: repeat;
  height: 100%;
  /* max-height: 100vh; */
}

.updateDiagram {
  position: absolute;
  background-color: white;
  height: calc(100% - 7px);
  top: 0;
  right: 0;
  z-index: 1000;
}

.none {
  transform: translateX(0%);
  transition: 0.4s;
}

.updateDiagram.updateNode {
  width: 50%;
  min-width: 800px;
}

.updateDiagram.updateLine {
  width: 45%;
  min-width: 500px;
}

.dialogCauHinhLuong .btn-add-docs {
  box-shadow: 0 0.5px 1.5px 0 rgba(0, 0, 0, 0.15),
    0 1px 1.5px 0 rgba(0, 0, 0, 0.08);
}

.dialogCauHinhLuong .btn-add-docs span {
  font-size: 13px;
  color: #005eb1;
}

.dialogCauHinhLuong .unit_selected img {
  width: 14px;
  height: 14px;
  padding: 0 11px;
  opacity: 0.5;
}

.dialogCauHinhLuong .unit_selected span {
  color: #2d3e4f;
  font-size: 14px;
}

.point.chart_act_0 {
  color: #9cc;
}

.point.chart_act_1 {
  color: #fac;
}

/* diagram cau hinh */
.jtk-overlay {
  padding: 5px;
  background-color: gray;
  cursor: pointer;
}

.jtk-overlay p {
  margin: 0;
  color: #fff;
}
</style>
<style lang="css" src="@/assets/css/diagram.css"></style>



// WEBPACK FOOTER //
// src/views/setting/cau-hinh-luong-v2/cau-hinh-luong-detail-v2.vue